import React, { useContext } from 'react';
import { AnimatePresence } from 'framer-motion';
import { RouteComponentProps, Route, Switch } from 'react-router';
import urlJoin from 'url-join';
import { useAuth0 } from 'Auth';
import {
  AnimatedRedirect,
  AnimatedScreen,
} from 'Shared/components/AnimatedScreen';
import { env } from 'Shared/constants/env';
import { managePartnerPermissionsPolicy } from 'Admin/authPolicies';
import {
  PartnerDetails,
  PartnerAgencies,
  Compliance,
  PartnerUsers,
  Permissions,
  Router as ReattributionRouter,
  CreatePartnerDetails,
  CommissionsRouter,
} from 'Admin/Partners/screens';
import { CreateUserDetails, UserDetails } from 'Admin/Users/screens';
import { PartnerContext } from 'Admin/utils';

export const PartnerRouter: React.FC<RouteComponentProps> = ({ match }) => {
  const { user } = useAuth0();
  const { currentPartner } = useContext(PartnerContext);

  const canManagePermissions = managePartnerPermissionsPolicy(
    user!.effectiveGrants,
    currentPartner
  );

  return (
    <AnimatedScreen>
      <AnimatePresence mode="wait">
        <Switch>
          <Route
            path={urlJoin(match.url, '/details')}
            component={PartnerDetails}
          />
          {canManagePermissions && (
            <Route
              path={urlJoin(match.url, '/permissions')}
              component={Permissions}
            />
          )}
          <Route
            path={urlJoin(match.url, '/reattribution')}
            component={ReattributionRouter}
          />
          {/* Carrier check will move to permissions policy when new roles & permissions are done */}
          {env.partnerCommissionsAdminMenuEnabled &&
            !currentPartner?.isCarrier && (
              <Route
                path={urlJoin(match.url, '/commissions')}
                component={CommissionsRouter}
              />
            )}
          <Route
            path={urlJoin(match.url, '/compliance')}
            component={Compliance}
          />
          <Route
            path={urlJoin(match.url, '/agencies/create')}
            component={CreatePartnerDetails}
          />
          <Route
            path={urlJoin(match.url, '/agencies')}
            component={PartnerAgencies}
          />
          <Route
            path={urlJoin(match.url, '/users')}
            component={PartnerUsers}
            exact={true}
          />
          {/* '/users/create' route needs to be before '/users/:userId' route */}
          <Route
            path={urlJoin(match.url, '/users/create')}
            component={CreateUserDetails}
            exact={true}
          />
          <Route
            path={urlJoin(match.url, '/users/:userId')}
            component={UserDetails}
          />
          <AnimatedRedirect
            to={urlJoin(match.url, '/details')}
            from={match.url}
          />
        </Switch>
      </AnimatePresence>
    </AnimatedScreen>
  );
};
